import { BaseWebComponent } from "./webcomponent-base";

export class SidebarAvatarWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-avatar";
    static observedAttributes = [];
    get fallback(): string {
        return this.getAttribute('fallback') || "";
    }
    private _fileInputId!: string;
    public get fileInputId(): string {
        if (!this._fileInputId) {
            this._fileInputId = this.createRandomId();
        }
        return this._fileInputId;
    }
    public set fileInputId(value: string) {
        this._fileInputId = value;
    }
    private _avatarDataUrl: string | null = null;
    public get avatarDataUrl(): string | null {
        if (this._avatarDataUrl === null) {
            this._avatarDataUrl = this.loadAvatarFromLocalStorage();
        }
        return this._avatarDataUrl;
    }
    public set avatarDataUrl(value: string | null) {
        this._avatarDataUrl = value;
        if (value) {
            this.saveAvatarToLocalStorage(value);
        }
        this.render();
    }
    private saveAvatarToLocalStorage(avatarDataUrl: string): void {
        localStorage.setItem('sidebar-avatar', avatarDataUrl);
    }
    private loadAvatarFromLocalStorage(): string | null {
        return localStorage.getItem('sidebar-avatar');
    }
    constructor() {
        super();
        this.setupEventListeners();
    }
    setupEventListeners(): void {
        
        this.addEventListener('avatar-change', (event) => {
            const evt = event as CustomEvent;
            const detail = evt.detail;
            if (detail && detail.dataUrl) {
                this.avatarDataUrl = detail.dataUrl;
            }
        })
        this.on('click', `[data-action="remove"]`, (event) => {
            event.preventDefault();
            localStorage.removeItem('sidebar-avatar');
            this.avatarDataUrl = null;
        })
    }
    private fileInputElement!: HTMLInputElement;
    onConnected(): void {
        document.body.insertAdjacentHTML('beforeend', `
            <input type="file" id="${this.fileInputId}" style="display:none" accept="image/jpeg,image/png" />
        `);
        this.fileInputElement = document.getElementById(this.fileInputId) as HTMLInputElement;
        this.fileInputElement.addEventListener('change', (event) => {
            const input = event.target as HTMLInputElement;
            if (input.files && input.files[0]) {
                const file = input.files[0];
                const reader = new FileReader();
                reader.onload = (e) => {
                    const result = e.target?.result as string;
                    this.dispatchEvent(new CustomEvent('avatar-change', {
                        detail: {
                            file: file,
                            dataUrl: result
                        }
                    }));
                };
                reader.readAsDataURL(file);
            }
        });
        this.render();
    }
     async render(): Promise<void> {
        const lines = [];
        lines.push(`<div class="tools-avatar">`);
        if (this.avatarDataUrl) {
            lines.push(`<a href="#" data-action="remove" title="rimuovi immagine"><i class="bi bi-trash"></i></a>`);
        }
        lines.push(`<label for="${this.fileInputId}"  title="imposta immagine"><i class="bi bi-pencil"></i></label>`);
        lines.push(`</div>`);
        lines.push(`<div class="sidebar-avatar">`);
        lines.push(`${this.fallback}`);
        lines.push(`</div>`);
        this.innerHTML = lines.join('\n');
        if (this.avatarDataUrl) {
            const img = document.createElement('img');
            img.src = this.avatarDataUrl;
            img.alt = "User Avatar";
            img.className = "sidebar-logo";
            const divAvatar = this.querySelector('.sidebar-avatar');
            if (divAvatar) {
                // inserisco l'immagine dentro la label
                divAvatar.innerHTML = '';
                divAvatar.appendChild(img);
            }
        }
    }
}

